"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.intro.start': '开始入职',
    'onboarding.intro.optimize': '优化操作和流程',
    'onboarding.intro.moment': '现在是策略性实施高级AI助手的时候了。',
    'onboarding.intro.enables': '在公司中使用它们可以：',
};
